// src/components/book/BookFilters.jsx
import React from 'react';
import '../../styles/book/BookFIlters.css';

const BookFilters = ({
  searchTerm,
  setSearchTerm,
  genres,
  selectedGenre,
  setSelectedGenre,
  priceRange,
  setPriceRange,
  sortBy,
  setSortBy,
}) => {
  const handlePresetPrice = (e) => {
    if (e.target.value === 'all') setPriceRange([0, 100]);
    if (e.target.value === 'under20') setPriceRange([0, 20]);
    if (e.target.value === '20plus') setPriceRange([20, 100]);
  };

  // Update CSS variables for bubbles
  const leftPos = `${priceRange[0]}%`;
  const rightPos = `${priceRange[1]}%`;

  return (
    <div className="book-filters">
      {/* Search */}
      <div className="filter-group">
        <label className="filter-label">Search</label>
        <input
          type="text"
          value={searchTerm}
          placeholder="Title or author..."
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>

      {/* Genre */}
      <div className="filter-group">
        <label className="filter-label">Genre</label>
        <select
          value={selectedGenre || 'All Genres'}
          onChange={(e) => setSelectedGenre(e.target.value)}
          className="filter-select"
        >
          {genres.map((genre) => (
            <option key={genre} value={genre}>
              {genre}
            </option>
          ))}
        </select>
      </div>

      {/* Price */}
      <div className="filter-group">
        <label className="filter-label">
          Price: ${priceRange[0]} — ${priceRange[1]}
        </label>

        {/* Preset price options */}
        <select onChange={handlePresetPrice} className="filter-select">
          <option value="all">All Prices</option>
          <option value="under20">Under $20</option>
          <option value="20plus">$20+</option>
        </select>

        {/* Enhanced price slider */}
        <div
          className="price-slider-container"
          style={{ '--min-pos': leftPos, '--max-pos': rightPos }}
        >
          <div
            className="price-track-active"
            style={{
              left: leftPos,
              width: `calc(${priceRange[1]}% - ${priceRange[0]}%)`,
            }}
          />

          <div className="price-bubble left">${priceRange[0]}</div>
          <div className="price-bubble right">${priceRange[1]}</div>

          <input
            type="range"
            min="0"
            max="100"
            value={priceRange[0]}
            onChange={(e) =>
              setPriceRange([Math.min(Number(e.target.value), priceRange[1]), priceRange[1]])
            }
            className="price-slider"
          />

          <input
            type="range"
            min="0"
            max="100"
            value={priceRange[1]}
            onChange={(e) =>
              setPriceRange([priceRange[0], Math.max(Number(e.target.value), priceRange[0])])
            }
            className="price-slider"
          />
        </div>
      </div>
    </div>
  );
};

export default BookFilters;
